/**
 * Application configuration singleton.
 * All values injected at build time from env YAML via Vite.
 */
function resolveApiBaseUrl(): string {
  const configured = import.meta.env.VITE_API_BASE_URL;
  if (configured) {
    return configured;
  }
  // Fallback for local dev without .env file
  return '/api/v1';
}

export const appConfig = {
  apiBaseUrl: resolveApiBaseUrl(),
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL || 'info@boxinom.com',
  brandName: import.meta.env.VITE_BRAND_NAME || 'Car Pulse Tracker',
  companyName: import.meta.env.VITE_COMPANY_NAME || 'Boxinom Oy',
  companyUrl: import.meta.env.VITE_COMPANY_URL || 'https://boxinom.com/',
  partnerName: import.meta.env.VITE_PARTNER_NAME || 'Csitea Oy',
  partnerUrl: import.meta.env.VITE_PARTNER_URL || 'https://csitea.net',
  // Backend client-error telemetry endpoint (spec 037), relative to apiBaseUrl.
  telemetryPath: '/telemetry/errors',
} as const;
